import clamp from './clamp.js';
import inRange from './inRange.js';
import random from './random.js';

export default {
  clamp, inRange, random
};



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/number.default.js
// module id = 2193
// module chunks = 41